// extracted by mini-css-extract-plugin
export default {"mapBlock":"Map_mapBlock__NYrey","container":"Map_container__d-WL-","listBox":"Map_listBox__NK7cE","text":"Map_text__MZE7m"};